/*
 * @Author: cmchiu
 * @Date: 2022-08-31 14:22:55
 * @LastEditTime: 2022-10-28 15:59:24
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \LearningMarket\LearningMarket-ClientApp\src\main.js
 *
 */
import 'core-js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-TW'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

Vue.use(ElementUI, { locale, zIndex: 1000 })

// vxe-table參數設定
VXETable.setup({
    table: {
        showOverflow: true, // 设置所有内容过长时显示为省略号
        showHeaderOverflow: true, // 设置表头所有内容过长时显示为省略号
        autoResize: true, // 自动监听父元素的变化去重新计算表格
        stripe: true, // 是否带有斑马纹
        border: true, // 是否带有边框
        round: true, // 是否为圆角边框
        keepSource: true, // 是否保持原始值的状态
        rowConfig: {
            isCurrent: true, // 当鼠标点击行时，是否要高亮当前行
            isHover: true, // 当鼠标移到行时，是否要高亮当前行
        },
        columnConfig: {
            resizable: true, // 每一列是否启用列宽调整
        },
        pager: {
            size: 'small', // 尺寸
            align: 'right', // 对齐方式
            autoHidden: false, // 当只有一页时自动隐藏
            perfect: true, // 配套的样式
            // pageSize: 10, // 每页大小
            pageSizes: [10, 20, 30, 50, 100], // 每页大小选项列表
            pagerCount: 7, // 显示页码按钮的数量
            //   layouts: ['PrevJump', 'PrevPage', 'Jump', 'PageCount', 'NextPage', 'NextJump', 'Sizes', 'Total'] // 自定义布局
        },
    },
    // // 對vxe-table組件內置的提示語進行國際化翻譯
    // i18n: (key, args) => i18n.t(key, args),
})
Vue.use(VXETable)

// 自定义监听sessionStorage的方法
Vue.prototype.$addStorageEvent = function (type, key, data) {
    if (type === 'setItem') {
        //type为setItem时执行下面的方法
        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent')
        const storage = {
            setItem: function (k, val) {
                sessionStorage.setItem(k, val)
                // 初始化创建的事件
                newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
                // 派发对象
                window.dispatchEvent(newStorageEvent)
            },
        }
        return storage.setItem(key, data)
    }
}

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
